import { useEffect, useRef, useState } from "react";
import { Play } from "lucide-react";
import { imageUrl } from "@/lib/api";
import { cn } from "@/lib/utils";

const touchOnly = () => window.matchMedia?.("(hover: none)").matches;

export const CardVideo = ({ path, id }) => {
  const ref = useRef(null);
  const [src, setSrc] = useState(null);
  const [playing, setPlaying] = useState(false);

  const play = () => { setSrc(imageUrl(path)); ref.current?.play?.().catch(() => {}); };
  const stop = () => { const v = ref.current; if (v) { v.pause(); } };

  useEffect(() => {
    const v = ref.current;
    const card = v?.closest("article");
    if (!v || !card) return undefined;
    if (touchOnly()) {
      const io = new IntersectionObserver(([e]) => (e.isIntersecting && e.intersectionRatio > 0.6 ? play() : stop()), { threshold: [0, 0.6, 1] });
      io.observe(v);
      return () => io.disconnect();
    }
    card.addEventListener("mouseenter", play);
    card.addEventListener("mouseleave", stop);
    return () => { card.removeEventListener("mouseenter", play); card.removeEventListener("mouseleave", stop); };
  }, [path]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { if (src) ref.current?.play?.().catch(() => {}); }, [src]);

  return (
    <>
      <video ref={ref} src={src || undefined} muted loop playsInline preload="none" aria-hidden
        onPlaying={() => setPlaying(true)} onPause={() => setPlaying(false)}
        className={cn("absolute inset-0 h-full w-full object-cover transition-opacity duration-500", playing ? "opacity-100" : "opacity-0")} data-testid={`card-video-${id}`} />
      <span className={cn("absolute bottom-3 left-3 inline-flex items-center gap-1 rounded-full bg-background/70 px-2.5 py-1 text-xs backdrop-blur transition-opacity", playing && "opacity-0")} data-testid={`card-video-badge-${id}`}>
        <Play className="h-3 w-3 fill-current" /> Video
      </span>
    </>
  );
};
